import { Injectable } from '@angular/core';

import { IEntityConfig, ENTITY_TYPES, BackendApiType } from '@app/shared/types';

import { BaseService } from '../base';

const entityType: ENTITY_TYPES = ENTITY_TYPES.EVENT_TYPE;
const config: IEntityConfig = {
  backendApiType: BackendApiType.DM,
  ENTITY_TYPE: entityType,
  isMasterListAvailable: true,
  apiEndpoint: entityType,
  uiRoute: entityType,
  customEntityRoute: {
    list: 'master',
  },
  buttons: {},
};

@Injectable()
export class EventTypeService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
}
